import { IOptionsWithTypes, PassengersList } from '@eventr/common'
import { useMemo } from 'react'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'
import { ChatButton } from '../subComponents/chatButton'
import { EditButton } from '../subComponents/editButton'
import { ExpandableSection } from '../subComponents/expendableSection'
import { FlightAttachments } from './flightAttachments'
import { FlightPassengers } from './flightPassengers'
import { FlightPersonalItems } from './flightPersonalItems'

interface IFlightBookingInfoProps {
    passenger?: PassengersList
    attachments?: { notes?: string; extra_docs?: string; website?: string }
    passengers?: PassengersList[]
    chatNames?: string[]
}
export const FlightBookingInfo = ({
    passenger,
    attachments,
    passengers,
    chatNames,
}: IFlightBookingInfoProps) => {
    const { screenType } = useScreenTypeContext()
    const { _id, sectionID } = useObjectContext()
    const mid = useMemo(() => {
        if (!passenger?.booking_ref) {
            return <CardText>{cardTranslation('Booking Information')}</CardText>
        }

        return <CardText> {passenger?.booking_ref}</CardText>
    }, [passenger?.booking_ref])

    const allPassengers = useMemo(() => {
        const all: IOptionsWithTypes[] = []
        passengers?.forEach((passenger) => {
            all.push(...(passenger.users ?? []))
        })
        return all
    }, [passengers])

    const end = useMemo(() => {
        if (screenType === 'edit')
            return <EditButton path={`/edit/Section/${sectionID}/${_id}`} />
        if (chatNames) {
            return (
                <ChatButton _id={_id} users={allPassengers} names={chatNames} />
            )
        }
        return null
    }, [screenType, _id, sectionID, chatNames, allPassengers])
    return (
        <ExpandableSection mid={mid} end={end}>
            <>
                {attachments && (
                    <FlightAttachments
                        notes={attachments.notes}
                        extra_docs={attachments.extra_docs}
                        website={attachments.website}
                    />
                )}
                {passenger && (
                    <FlightPersonalItems
                        baggage_allowance={passenger.baggage_allowance}
                        documents={passenger.documents}
                        notes={passenger.notes}
                    />
                )}
                {allPassengers && (
                    <FlightPassengers passengers={allPassengers} />
                )}
            </>
        </ExpandableSection>
    )
}
